/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum GlobalError {
	None = 'None',
	BillingFailure = 'BillingFailure',
	BillingRequiresAuthentication = 'BillingRequiresAuthentication',
	EntryLimitExceeded = 'EntryLimitExceeded',
	StorageLimitExceeded = 'StorageLimitExceeded',
	HasLockedUsers = 'HasLockedUsers',
	HasLockedEmailDomains = 'HasLockedEmailDomains',
	MissingTaxInformation = 'MissingTaxInformation',
	PaymentAccountDisabled = 'PaymentAccountDisabled',
	PayoutsDisabled = 'PayoutsDisabled',
	BillingPastDue = 'BillingPastDue',
	BillingRestricted = 'BillingRestricted',
}
